<template>
    <div class="px-2 relative next-table-tooltip">
        <p class="truncate"><slot></slot></p>
        <div class="hidden absolute inset-0 w-full border-next-gray-md pb-2">
            <div
                class="px-2 bg-next-gray-md rounded outline outline-1 z-10 shadow"
                :class="inner_class"><slot></slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'TableTooltip',
    components: {
    },
    props:{
        inner_class: String
    }
})
export default class TableTooltip extends Vue {

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
